<template>
    <div class="p-lg-4">
        <div class="row">
            <div class="col-12 ps-4 ms-2">
                <h2>{{ $t("titles.orders") }}</h2>
            </div>
            <div class="col-12 d-flex justify-content-end gap-2">
                <div v-if="$store.getters.hasPerm('can_export_orders')">
                    <button class="btn btn-primary button-top" data-bs-toggle="modal" data-bs-target="#exportOrders">
                        {{ $t("orders.exportOrderPdf") }}
                    </button>
                </div>
                <div v-if="$store.getters.hasPerm('add_order')">
                    <button @click="createOrder()" class="btn btn-primary button-top">
                        {{ $t("orders.addOrder") }}
                    </button>
                </div>
            </div>
        </div>
        <Table endpoint="/orders" ref="table" class="mt-3" :filters="filters">
            <template v-slot:filters>
                <!-- First row -->
                <div class="row g-3">
                    <!-- Interní ID -->
                    <div class="col-12 col-sm-6 col-md-4 col-lg-2">
                        <label>{{ $t("orders.id") }}</label>
                        <input type="text" class="form-control" placeholder="23010001" v-model="filters.internId">
                    </div>

                    <!-- Created date (jen pokud má permission) -->
                    <div class="col-12 col-sm-6 col-md-4 col-lg-2" v-if="$store.getters.hasPerm('add_order')">
                        <label>{{ $t("orders.createdDate") }}</label>
                        <input type="date" class="form-control mb-1" v-model="filters.createdDateStart">
                        <input type="date" class="form-control" v-model="filters.createdDateEnd">
                    </div>

                    <!-- Delivery date -->
                    <div class="col-12 col-sm-6 col-md-4 col-lg-2">
                        <label>{{ $t("orders.deliveryDate") }}</label>
                        <input type="date" class="form-control mb-1" v-model="filters.expectedDeliveryDateStart">
                        <input type="date" class="form-control" v-model="filters.expectedDeliveryDateEnd">
                    </div>

                    <!-- Name / Title -->
                    <div class="col-12 col-sm-6 col-md-4 col-lg-2">
                        <label>{{ $t("orders.name") }}/{{ $t("orders.title") }}</label>
                        <input type="text" class="form-control" placeholder="Matěj Marek" v-model="filters.name">
                    </div>

                    <!-- Phone -->
                    <div class="col-12 col-sm-6 col-md-4 col-lg-2">
                        <label>{{ $t("orders.phone") }}</label>
                        <input type="text" class="form-control" placeholder="736109281" v-model="filters.wholePhone">
                    </div>

                    <!-- Address -->
                    <div class="col-12 col-sm-6 col-md-4 col-lg-2">
                        <label>{{ $t("orders.address") }}</label>
                        <input type="text" class="form-control" placeholder="Ulice 11, 110 00 Město"
                            v-model="filters.fullAddress">
                    </div>
                </div>

                <!-- warehouse, state, adtype -->
                <div class="row g-3 align-items-end">
                    <div class="col-12 col-sm-6 col-md-4 col-lg-2">
                        <label>{{ $t("orders.warehouse") }}</label>
                        <select class="form-select" v-model="filters.warehouse" @change="searchFirstPage">
                            <option :value="null">Všechny</option>
                            <option v-for="warehouse in warehouses" :key="warehouse.id" :value="warehouse.id">{{
                                warehouse.name }}</option>
                        </select>
                    </div>

                    <div class="col-12 col-sm-6 col-md-4 col-lg-2">
                        <label>{{ $t("orders.orderState") }}</label>
                        <select class="form-select" v-model="filters.state" @change="searchFirstPage">
                            <option :value="null">vše</option>
                            <option value="not_done">nedokončeno</option>
                            <option value="done">dokončeno</option>
                            <option value="hidden">zrušeno</option>
                            <option value="not_collected">nepřevzato</option>
                        </select>
                    </div>

                    <div class="col-12 col-sm-6 col-md-4 col-lg-2" v-if="$store.getters.hasPerm('add_order')">
                        <label>{{ $t("orders.adtypes") }}</label>
                        <select class="form-select" v-model="filters.adtype" @change="searchFirstPage">
                            <option :value="null">vše</option>
                            <option v-for="adtype in adtypes" :key="adtype.id" :value="adtype.id">{{ adtype.name }}
                            </option>
                        </select>
                    </div>
                </div>

                <!-- Buttons -->
                <div class="row g-3 mt-3 mb-4">
                    <div class="col-12 col-sm-6 col-md-4 col-lg-2">
                        <button class="btn btn-primary btn-color-white w-100" @click="clearFilters">{{
                            $t("utils.clearFilters")
                        }}</button>
                    </div>

                    <div v-if="$store.getters.hasPerm('can_export_delivery_notes')"
                        class="col-12 col-sm-6 col-md-4 col-lg-2">
                        <button class="btn btn-primary btn-color-white w-100" data-bs-toggle="modal"
                            data-bs-target="#deliveryNotes">
                            {{ $t("utils.downloadDeliveryNotes") }}
                        </button>
                    </div>
                </div>
            </template>

            <template v-slot:header>
                <div class="row d-none d-lg-flex">
                    <div v-if="$store.getters.hasPerm('can_export_delivery_notes')" class="col-lg-1">
                        <input type="checkbox" class="form-check-input" @click="selectAll()">
                    </div>
                    <div class="col-lg-1">{{ $t("orders.id") }}</div>
                    <div class="col-lg-1">{{ $t("orders.deliveryDate") }}</div>
                    <div class="col-lg-2">{{ $t("orders.name") }}</div>
                    <div class="col-lg-2">{{ $t("orders.phone") }}</div>
                    <div class="col-lg-3">{{ $t("orders.address") }}</div>
                    <div class="col-lg-2">{{ $t("orders.action") }}</div>
                </div>
            </template>
            <template #row="line">
                <div class="row py-2 align-items-start">
                    <!-- Checkbox -->
                    <div v-if="$store.getters.hasPerm('can_export_delivery_notes')"
                        class="col-12 col-lg-1 mb-2 mb-lg-0">
                        <input type="checkbox" class="form-check-input"
                            :checked="selectedDeliveryNotes.includes(line.item.id)"
                            @change="selectDeselect(line.item.id)">
                    </div>
                    <!-- ID -->
                    <div class="col-12 col-lg-1">
                        <small class="text-muted d-lg-none">{{ $t("orders.id") }}</small>
                        <div>
                            {{ line.item.intern_id }}
                            <span v-if="line.item.special_mark" class="badge bg-danger ms-1"
                                :title="$t('orders.specialMark')">⚠ {{ $t("orders.specialMarkShort") }}</span>
                        </div>
                    </div>
                    <!-- Delivery date -->
                    <div class="col-12 col-lg-1">
                        <small class="text-muted d-lg-none">{{ $t("orders.deliveryDate") }}</small>
                        <div>{{ line.item.expected_delivery_date }}</div>
                    </div>
                    <!-- Name -->
                    <div class="col-12 col-lg-2">
                        <small class="text-muted d-lg-none">{{ $t("orders.name") }}</small>
                        <div>
                            {{ line.item.customer.name }}
                            <span v-if="line.item.customer.organization_id">
                                ({{ line.item.customer.organization_name }},
                                {{ line.item.customer.organization_id }})
                            </span>
                        </div>
                    </div>
                    <!-- Phone -->
                    <div class="col-12 col-lg-2">
                        <small class="text-muted d-lg-none">{{ $t("orders.phone") }}</small>
                        <div>{{ line.item.customer.whole_phone }}</div>
                    </div>
                    <!-- Address -->
                    <div class="col-12 col-lg-3">
                        <small class="text-muted d-lg-none">{{ $t("orders.address") }}</small>
                        <div>{{ line.item.customer.address.full_address }}</div>
                    </div>
                    <!-- Actions -->
                    <div class="col-12 col-lg-2 mt-2 mt-lg-0 d-flex flex-wrap gap-2">
                        <router-link :to="'/order/' + line.item.id" class="btn btn-primary text-white">
                            {{ $t("utils.detail") }}
                        </router-link>
                        <router-link v-if="!line.item.hidden && $store.getters.hasPerm('change_order')"
                            :to="'/order/' + line.item.id + '/items'" class="btn btn-primary text-white">
                            {{ $t("utils.edit") }}
                        </router-link>
                        <button v-if="!line.item.hidden && $store.getters.hasPerm('change_order')"
                            @click="hideOrder(line.item.id)" class="btn btn-sm btn-outline-danger">
                            {{ $t("utils.cancel") }}
                        </button>
                        <button v-else-if="$store.getters.hasPerm('change_order')" @click="restoreOrder(line.item.id)"
                            class="btn btn-sm btn-outline-success">
                            {{ $t("utils.restore") }}
                        </button>
                    </div>
                </div>
            </template>
        </Table>
    </div>

    <!-- Modal for delivery notes -->
    <div class="modal fade" id="deliveryNotes" tabindex="-1" aria-labelledby="deliveryNotesLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="deliveryNotesLabel">{{ $t('orders.makeDeliveryNote') }}</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <div class="mb-3 w-50">
                        <label for="deliveryNotesDate" class="form-label">{{ $t('orders.supplier') }}</label>
                        <select class="form-select" v-model="supplier" id="supplier">
                            <option v-for="supplier in suppliers" :value="supplier.id">
                                {{ supplier.name }}
                            </option>
                        </select>
                    </div>
                    <div class="mb-3 w-50">
                        <label for="deliveryNotesDate" class="form-label">{{ $t('orders.language') }}</label>
                        <select class="form-select" v-model="language" id="language">
                            <option value="cs">
                                Čeština
                            </option>
                            <option value="de">
                                Němčina
                            </option>
                        </select>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
                        <span>{{ $t('utils.close') }}</span>
                    </button>
                    <button type="button" class="btn btn-primary" @click="downloadDeliveryNotes()">
                        <span>{{ $t('utils.submit') }}</span>
                    </button>
                </div>
            </div>
        </div>
    </div>

    <!-- Modal for export orders -->
    <div class="modal fade" id="exportOrders" tabindex="-1" aria-labelledby="exportOrdersLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="exportOrdersLabel">{{ $t("orders.exportOrderPdf") }}</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body row">
                    <div class="mb-3 col-6">
                        <label for="exportOrdersSelect" class="form-label">{{ $t("orders.warehouse") }}</label>
                        <select id="exportOrdersSelect" class="form-select" v-model="selectedWarehouse">
                            <option v-for="warehouse in warehouses" :value="warehouse.id" :key="warehouse.id">
                                {{ warehouse.name }}
                            </option>
                            <option value="all">{{ $t("utils.all") }}</option>
                        </select>
                    </div>
                    <div class="mb-3 col-6">
                        <label for="exportOrdersSelect" class="form-label">{{ $t("orders.exportBy") }}</label>
                        <select id="exportOrdersBy" class="form-select" v-model="ordersExport.exportBy">
                            <option value="created">{{ $t("orders.created") }}</option>
                            <option value="shipped">{{ $t("orders.shipped") }}</option>
                        </select>
                    </div>
                    <div class="col-6">
                        <label class="form-label">{{ $t("orders.from") }}</label>
                        <input type="date" class="form-control" v-model="ordersExport.from" />
                    </div>
                    <div class="col-6">
                        <label class="form-label">{{ $t("orders.to") }}</label>
                        <input type="date" class="form-control" v-model="ordersExport.to" />
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
                        <span>{{ $t('utils.close') }}</span>
                    </button>
                    <button type="button" class="btn btn-primary" @click="downloadOrders">
                        <span>{{ $t('utils.submit') }}</span>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Table from "@/components/Table.vue";

export default {
    components: {
        Table
    },
    data() {
        return {
            warehouses: [],
            adtypes: [],
            supplier: null,
            language: null,
            suppliers: [],
            filters: {
                internId: null,
                expectedDeliveryDateStart: null,
                expectedDeliveryDateEnd: null,
                name: null,
                wholePhone: null,
                fullAddress: null,
                warehouse: null,
                adtype: null,
                createdDateStart: null,
                createdDateEnd: null,
                state: null
            },
            selectedDeliveryNotes: [],
            selectedWarehouse: null,
            ordersExport: {
                from: this.getToday(),
                to: this.getToday(),
                exportBy: 'shipped'
            }
        }
    },
    created: function () {
        this.loadData();
        if (this.$store.getters.orderFilters) {
            this.filters = this.$store.getters.orderFilters;
        }
    },
    watch: {
        filters: {
            handler: function () {
                this.$store.commit("updateOrderFilters", this.filters);
            },
            deep: true
        },
    },
    methods: {
        loadData: function () {
            this.$store.getters.api.get("/warehouses/own").then((response) => {
                this.warehouses = response.data.items;
            });
            if (this.$store.getters.hasPerm('add_order')) {
                this.$store.getters.api.get('/adtypes').then(function (response) {
                    this.adtypes = response.data.items;
                }.bind(this));
            }
            if (this.isOwnerOrDispecher()) {
                this.$store.getters.api.get("/suppliers").then((response) => {
                    this.suppliers = response.data.items;
                })
            }
        },
        hideOrder: function (id) {
            this.$store.getters.api.delete("/order/" + id + "/delete").then((response) => {
                this.$refs.table.loadData();
            }).catch((response) => {
                alert(this.$t("error." + response?.response?.data?.error_code));
            });
        },
        restoreOrder: function (id) {
            this.$store.getters.api.put("/order/" + id + "/restore").then((response) => {
                this.$refs.table.loadData();
            }).catch((response) => {
                alert(this.$t("error." + response?.response?.data?.error_code));
            });
        },
        createOrder: function () {
            this.$store.getters.api.get("/order/add").then((response) => {
                this.$router.push({ name: "UpdateOrderCustomer", params: { id: response.data.id } })
            })
        },
        clearFilters: function () {
            this.filters = {
                internId: null,
                expectedDeliveryDateStart: null,
                expectedDeliveryDateEnd: null,
                name: null,
                wholePhone: null,
                fullAddress: null,
                warehouse: null,
                adtype: null,
                createdDateStart: null,
                createdDateEnd: null,
                state: null
            }
        },
        selectDeselect(id) {
            if (this.selectedDeliveryNotes.includes(id)) {
                this.selectedDeliveryNotes.splice(this.selectedDeliveryNotes.indexOf(id), 1);
                return;
            }
            this.selectedDeliveryNotes.push(id);

        },
        selectAll() {
            if (this.selectedDeliveryNotes.length == this.$refs.table.items.length) {
                this.selectedDeliveryNotes = [];
            } else {
                const allItems = this.$refs.table.items;
                this.selectedDeliveryNotes = allItems.map(item => item.id);
            }
        },
        downloadDeliveryNotes() {
            if (this.selectedDeliveryNotes.length > 0) {
                this.$store.getters.api.get("download_multiple_delivery_notes", {

                    responseType: 'blob',
                    params: { orders: this.selectedDeliveryNotes, language: this.language, supplier: this.supplier }
                }).then((response) => {

                    const url = window.URL.createObjectURL(new Blob([response.data]));

                    // Create a link element to trigger the download
                    const link = window.document.createElement('a');

                    // Set the filename from the server or fallback to a default name
                    link.href = url;

                    // Use the Blob type to determine the filename with extension
                    link.setAttribute('download', `sloucene_dodaci_list.pdf`);
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                });
            }
        },
        downloadOrders() {
            if (this.selectedWarehouse && this.ordersExport.from) {
                this.$store.getters.api.get("download-orders", {
                    responseType: "blob",
                    params: {
                        warehouse: this.selectedWarehouse,
                        from: this.ordersExport.from,
                        to: this.ordersExport.to,
                        exportBy: this.ordersExport.exportBy
                    }
                }).then(res => {
                    const url = window.URL.createObjectURL(new Blob([res.data]));
                    const link = document.createElement("a")

                    link.href = url;
                    link.setAttribute("download", "objednavky.pdf");

                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                }).catch(error => {
                    console.error("Error export.", error);
                })
            }
        },
        getToday() {
            const today = new Date();
            return today.toISOString().split("T")[0]
        },
        isOwnerOrDispecher: function () {
            var isOwnerOrDispecher = false;
            this.$store.state.user.functions.forEach(element => {
                if (element.name == "owner") {
                    isOwnerOrDispecher = true;
                }
                else if (element.name == "dispatcher") {
                    isOwnerOrDispecher = true;
                }
            })
            return isOwnerOrDispecher;
        },
    },
}
</script>
<style lang="">

</style>